import axios from './index'
import prefix_ms from './prefix'

// /userArticleCalendar/all/user
// 获取用户全部文章日历(by userId)
export const getUserArticleCalendarUser = (params) => {
  return axios.request({
    url: prefix_ms + `/userArticleCalendar/all/user`,
    method: 'get',
    params: params,
  })
}

// /userArticleCalendar/someday
// 获取用户某日的阅读详情
export const getUserArticleCalendarSomeday = (params) => {
  return axios.request({
    url: prefix_ms + `/userArticleCalendar/someday`,
    method: 'get',
    params: params,
  })
}

// /userArticleCalendar/someday
// 获取用户某日的阅读详情
export const getUserArticleCalendarSomedayByUserId = (params) => {
  return axios.request({
    url: prefix_ms + `/userArticle/someday/byUserId`,
    method: 'get',
    params: params,
  })
}




// /v2/userReadCalendar/month
// 获取某月阅读日历
export const getV2CalendarMonth = (params) => {
  return axios.request({
    url: prefix_ms + `/userReadCalendar/month`,
    method: 'get',
    params: params,
  })
}


// /v2/userReadCalendar/month
// 通过用户id获取某月阅读日历
export const getV2CalendarMonthByUserId = (params) => {
  return axios.request({
    url: prefix_ms + `/userReadCalendar/month/byUserId`,
    method: 'get',
    params: params,
  })
}

// /v2/userArticle/someday
// 获取某日阅读文章记录
export const getV2UserArticleSomeday = (params) => {
  return axios.request({
    url: prefix_ms + `/userArticle/someday`,
    method: 'get',
    params: params,
  })
}

// /v2/userArticle/read/detail
// 获取某篇文章阅读详情
export const getV2ReadArticleDetail = (params) => {
  return axios.request({
    url: prefix_ms + `/userArticle/read/detail`,
    method: 'get',
    params: params,
  })
}

// /v2/userArticle/read/detail
// 获取某篇文章阅读详情
export const getV2ReadArticleDetailByUserId = (params) => {
  return axios.request({
    url: prefix_ms + `/userArticle/read/detail/byUserId`,
    method: 'get',
    params: params,
  })
}



//////////////////
// WEBPACK FOOTER
// ./app/api/userArticle.js
// module id = null
// module chunks = 